export default __webpack_public_path__ + "static/media/logo-projects.553f2313.svg";